import { ClientesFinalesPage } from "@/features/clientesFinales";

export default function ClientesFinales() {
  return <ClientesFinalesPage scope="owned" />;
}
